<script lang="ts">
  import WorkOrderAppointmentTag from "../../../../../../../_shared/_modules/work-order-appointment-tag"
  import type { WorkOrderRow } from "../../../../_logic/work-order-table-model"

  type Props = {
    row: WorkOrderRow
  }

  const { row }: Props = $props()
</script>

<WorkOrderAppointmentTag
  status={row.appointmentStatusDefinition}
  subLabel={row.appointmentSubLabel}
  tooltipContent={row.appointmentTooltip}
  historyItems={row.appointmentHistoryItems}
  historyLayout="stack"
  fallbackLabel={row.activeAppointmentLabel || "—"}
/>
